import { ApiConstant } from "@/const";
import { GSTApi } from "./config/api.config";

export const sendNoticeToDatalake = async () => {
  const response = await GSTApi.toCamel().post(ApiConstant.SEND_NOTICE_TO_DATALAKE, {
    content: "Hệ thống có phản hồi",
  });

  if (response.ok && response.data && response.data) {
    return response.data;
  }

  throw response;
};
